import React, { useState, useEffect } from "react";
import MultiSelector from "../../components/MultiSelector.js";

function FetchYears({ passData, selectionsLimit }) {
  const [years, setyears] = useState([]);

  useEffect(() => {
    var url = "/api/minmaxyears";

    fetch(url)
      .then((res) =>
        res.json().then((res) => {
          let years_list = [];
          for (let i = res.data.min_year; i <= res.data.max_year; i++) {
            years_list.push({ key: i });
          }

          setyears(years_list);
        })
      )
      .catch((error) => {
        console.log("Refetching data for Years!");
      });
  }, []);

  if (years.length === 0) {
    return <></>;
  } else {
    const YearSelectorOptions = {
      title: "",
      default_text: "Επέλεξε έτος",
      options: years,
    };

    return (
      <MultiSelector
        passData={passData}
        props={YearSelectorOptions}
        selectionsLimit={selectionsLimit}
      ></MultiSelector>
    );
  }
}

export default FetchYears;
